module.exports = __webpack_public_path__ + "static/img/kehuanli-4.a9f667c2.jpg";